<template>
  <section class="section white-panel">
    <h2 class="fs16 mt4 mb12">{{ transitionFrom === 'fromEstimate' ? 'この機会にお車の乗換をご検討のお客様へ' : 'リースのご紹介' }}</h2>
      <div>
        <p class="mb16 text-center">
            <a @click="$emit('toLeaseTop')"><img src="/lib/images/lease-promotion.png" alt=""></a>
        </p>
      </div>
  </section>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      sevenYearsAgo: ''
    }
  },
  props: [
    'car',
    'tsid',
    'otoken',
    'popInfoNo',
    'transitionFrom'
  ],
  methods: {
    dateParse (date) {
      const year = Number(date.substr(0, 4))
      const month = Number(date.substr(5, 2)) - 1
      return new Date(year, month)
    }
  },
  computed: {
    firstRegistrationOn () {
      return this.dateParse(this.car.first_registration_on)
    }
  },
  async mounted () {
    // 現在時刻より7年前の変数を作成
    this.sevenYearsAgo = moment().add(-7, 'years').toDate()
  }
}
</script>
